import { DatePickerInput } from "@/components/DatePicker";
import { DatePickerStyleContainer } from "@/components/InlineDatePicker";
import { LightMode } from "@repo/skapa";
import { FormField } from "@repo/skapa";
import { useTranslation } from "@repo/translation";
import { DATE_FORMAT, Label } from "@repo/ui";
import { useEffect, useRef } from "react";
import ReactDatePicker from "react-datepicker";

interface DatePickerFieldProps {
  label?: string;
  autoFocus?: boolean;
  id?: string;
  value?: Date;
  editable?: boolean;
  onChange?: (newValue?: Date) => void;
  isClearable?: boolean;
}
export const DatePickerField = ({
  id,
  autoFocus,
  label,
  value,
  editable,
  onChange,
  isClearable,
}: DatePickerFieldProps) => {
  const ref = useRef<any>(null);
  const { dateFnsLocale } = useTranslation();

  useEffect(() => {
    if (autoFocus) {
      ref?.current?.setFocus();
      ref?.current?.setOpen(true);
    }
  }, [autoFocus]);

  return (
    <FormField>
      <Label htmlFor={id ?? "date"} label={label} />
      <DatePickerStyleContainer
        border={`1px solid ${LightMode.colourNeutral3} `}
      >
        <ReactDatePicker
          ref={ref}
          id={id ?? "date"}
          disabled={editable === false}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              e.preventDefault();
              e.stopPropagation();
              ref?.current?.setOpen(false);
            }
          }}
          customInput={
            <DatePickerInput
              disabled={editable === false}
              onFocus={() => {
                if (!ref?.current?.isCalendarOpen()) {
                  ref?.current?.setOpen(true);
                }
              }}
            />
          }
          onChange={(date: Date | null) => {
            onChange?.(date ?? undefined);
          }}
          locale={dateFnsLocale}
          dateFormat={DATE_FORMAT}
          selected={value}
          isClearable={isClearable && editable !== false}
        />
      </DatePickerStyleContainer>
    </FormField>
  );
};
